export const CONSUMER_GPU_CPU_DATA = {
  title: "Consumer GPU ",
  data: [
    {
      cpu: "AMD RYZEN 3900X",
      memory: "64 GB",
      cockBoost: "3.8 GHZ | 4.6 GHZ",
      disk: "2×2TB",
      gpu: "NVIDIA RTX 2080Ti",
      monthlyPrice: 420,
    },
    {
      cpu: "AMD RYZEN 5900X",
      memory: "64 GB",
      cockBoost: "3.7 GHZ | 4.8 GHZ",
      disk: "2×2TB",
      gpu: "RTX 4080",
      monthlyPrice: 546,
    },
    {
      cpu: "AMD Ryzen™ 9 7950X3D 16C | 32T",
      memory: "128 GB",
      cockBoost: "4.2 GHZ | 5.7 GHZ",
      disk: "2×4TB",
      gpu: "NVIDIA T1000-8GB",
      monthlyPrice: 570,
    },
    {
      cpu: "AMD TR PRO 7965WX 24C | 48T",
      memory: "128 GB",
      cockBoost: "4.2 GHZ | 5.3 GHZ",
      disk: "2×256 | 2×4TB",
      gpu: "1×NVIDIA RTX™ A4000 16GB GDDR6",
      monthlyPrice: 810,
    },
    {
      cpu: "AMD TR PRO 7965WX 24C | 48T",
      memory: "256 GB",
      cockBoost: "4.2 GHZ | 5.3 GHZ",
      disk: "2×256 | 2×4TB",
      gpu: "2×NVIDIA RTX™ A4000 16GB GDDR6",
      monthlyPrice: 1170,
    },
    {
      cpu: "AMD TR PRO 7975WX 32C | 64T",
      memory: "128 GB",
      cockBoost: "4 GHZ | 5.3 GHZ",
      disk: "2×512 | 2×4TB",
      gpu: "1×NVIDIA RTX™ A4000 16GB GDDR6",
      monthlyPrice: 1050,
    },
    {
      cpu: "AMD TR PRO 7975WX 32C | 64T",
      memory: "256 GB",
      cockBoost: "4 GHZ | 5.3 GHZ",
      disk: "2×512 | 2×4TB",
      gpu: "2×NVIDIA RTX™ A4000 16GB GDDR6",
      monthlyPrice: 1290,
    },
    {
      cpu: "AMD TR PRO 7985WX 64C | 128T",
      memory: "512 GB",
      cockBoost: "3.2 GHZ | 5.1 GHZ",
      disk: "2×1TB | 4×4TB",
      gpu: "2×NVIDIA RTX™ A5000 32 GB GDDR6",
      monthlyPrice: 2880,
    },
    {
      cpu: "AMD TR PRO 7995WX 96C | 192T",
      memory: "1024 GB",
      cockBoost: "2.5 GHZ | 5.1 GHZ",
      disk: "2×1TB | 4×4TB",
      gpu: "2×NVIDIA RTX™ A5000 32 GB GDDR6",
      monthlyPrice: 3600,
    },
    {
      cpu: "AMD TR PRO 7995WX 96C | 192T",
      memory: "1024 GB",
      cockBoost: "2.5 GHZ | 5.1 GHZ",
      disk: "2×1TB | 4×4TB",
      gpu: "2×NVIDIA RTX™ A6000 48 GB GDDR6",
      monthlyPrice: 4200,
    },
  ],
};
